import React from "react";


const ProductTermsAndConditions = () => {
  return (
    <>
      <div className="policy-section-description">

      </div>

      <div className="pricing-section-description">
        <p className="pricing-product-para">
          <b className="disclaimer-subtitle">Note:</b> The above loan amounts and offers are based on bank
          policies and are subject to variation depending on the customer’s
          credit score, age, income, and employer. Loan approval or rejection is
          subject to the internal policies of the respective banks or lending
          institutions. Offers are subject to availability, and customers may
          receive different interest rates based on the bank’s real-time offers.
        </p>
        <h4 className="disclaimer-subtitle">Important Notice:</h4>
        <p className="pricing-product-para">
          <span className="pricing-reject-icon">●</span>
            Please read all terms and conditions carefully before applying,
            during documentation, and at the time of disbursal with the
            respective lending partner. Right Lender does not guarantee loan
            approval or disbursal, and is not liable for any direct decisions
            made by banks or NBFCs.<b> For any clarifications, write to us at support@rightlender.in or
            contact our helpline at +91-8610325366</b>
        </p>
      </div>
    </>
  );
};

export default ProductTermsAndConditions;
